<template>
  <transition name="fade">
    <div v-if="isSyncing || progress === 100" class="row mb-3">
      <div class="col-12">
        <div 
          class="alert d-flex flex-column shadow-sm"
          :class="alertClass"
          role="alert"
        >

          <div class="d-flex align-items-center w-100">
            <span class="spinner-border spinner-border-sm me-3 text-white"></span>

            <div class="flex-grow-1 text-white">
              <strong>
                {{ isCompleted 
                    ? $t('rvo.sync_completed') 
                    : $t('rvo.sync_in_progress') 
                }}
              </strong>

              <br>

              <small>
                {{ $t('rvo.please_be_patient') }}
              </small>

              <!--div class="mt-1">
                <small>
                  {{ $t('rvo.elapsed_time') }}: {{ elapsedFormatted }}
                </small>
              </div-->
            </div>

            <!--button
              class="btn btn-sm btn-danger ms-3"
              @click="cancelSync"
              :disabled="!cancelSource || isCompleted"
            >
              {{ $t('common.Cancel') }}
            </button-->

          </div>

          <!-- Progress Bar Section -->
          <div class="progress mt-3" style="height: 10px;">
            <div
              class="progress-bar bg-success progress-bar-striped progress-bar-animated"
              role="progressbar"
              :style="{ width: progress + '%', height: '100%' }"
              :aria-valuenow="progress"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>

          <div class="text-end mt-1 text-white">
            <small>
              {{ progress }} %
            </small>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'RvoSyncBanner',

  computed: {
    ...mapState('rvoSync', ['isSyncing', 'progress', 'cancelSource']),
    ...mapGetters('rvoSync', ['elapsedSeconds']),

    alertClass() {
      return this.elapsedSeconds > 15
        ? 'alert-warning'
        : 'alert-info';
    },

    elapsedFormatted() {
      const sec = this.elapsedSeconds;
      const minutes = Math.floor(sec / 60);
      const seconds = sec % 60;

      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    },

    isCompleted() {
      return this.progress === 100;
    }
  },

  watch: {
    progress(newVal) {
      // Auto hide banner shortly after completion
      if (newVal === 100) {
        // Wait 2.5 seconds so user can see "completed"
        setTimeout(() => {
          this.$store.commit('rvoSync/CLEAR_SYNC');
        }, 2500);
      }
    }
  },

  methods: {
    cancelSync() {
      if (!this.cancelSource || this.isCompleted) return;

      this.$store.commit('rvoSync/CANCEL_SYNC');
      this.$showError(this.$t('rvo.sync_cancelled'));
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.2s ease, transform 1.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.progress-bar {
  transition: width 0.6s ease-in-out;
}
</style>
